import { Outlet, useNavigate } from 'react-router-dom';
import { useAutoLogout } from '../../customHook/useAutoLogout';
import { useDispatch } from 'react-redux';
import { CLEAR_FORM_DATA } from '../../redux-state/types';
import { endSession } from '../authProvider/tabSession';

const AutoLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    // This tab's server session and storage. Other tabs have their own.
    endSession();
    dispatch({
      type: CLEAR_FORM_DATA,
    });
    navigate('/login');
  };

  useAutoLogout(handleLogout);

  return <Outlet />;
};

export default AutoLogout;
